import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=924b59f4&scoped=true&"
var script = {}
import style0 from "./Imprint.vue?vue&type=style&index=0&id=924b59f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924b59f4",
  null
  
)

export default component.exports